import { uniqBy } from "lodash";
import { useFormContext } from "react-hook-form";
import { ACTIONS } from "../ActionRule/useActionValidation";
import {
  isActionCompatibleWithTrigger,
  isActionLimitedToTriggers,
} from "../Actions/workflowsConfiguration";
import type { EventOption } from "./types";

export const useFilterEventsByRestrictedActions = (
  allAvailableEvents: readonly EventOption[],
) => {
  const { watch } = useFormContext();
  const actions = watch(ACTIONS, []);

  const restrictingActions =
    uniqBy(
      actions.filter((action: any) => {
        if (!action.action_type) return false;
        return isActionLimitedToTriggers(action.action_type);
      }),
      "action_type",
    ) ?? [];

  const hasRestrictingActions = restrictingActions.length > 0;

  let filteredEvents = allAvailableEvents;

  if (actions.length > 0) {
    filteredEvents = allAvailableEvents.filter(event =>
      // Event is only available if ALL actions are compatible with it
      actions.every((action: any) => {
        if (!action.action_type) return true;
        return isActionCompatibleWithTrigger(action.action_type, event.value);
      }),
    );
  }

  return {
    filteredEvents,
    restrictingActions,
    isEventsRestricted: hasRestrictingActions,
  };
};
